import React from 'react'
import {
  useMessageComposer,
  useStateStore,
  useTranslationContext,
} from 'stream-chat-react'
import SendIcon from 'components/material-symbol/icons/Send'

const textComposerStateSelector = state => state.text
const attachmentManagerStateSelector = state => state.attachments
const editingAuditStateSelector = state => state

const MessagingSendButton = ({ sendMessage, ...rest }) => {
  const { t } = useTranslationContext()
  const messageComposer = useMessageComposer()

  useStateStore(messageComposer.textComposer.state, textComposerStateSelector)
  useStateStore(
    messageComposer.attachmentManager.state,
    attachmentManagerStateSelector,
  )
  useStateStore(messageComposer.editingAuditState, editingAuditStateSelector)

  const hasSendableData = messageComposer.hasSendableData

  return (
    <button
      aria-label={t('aria/Send')}
      className="str-chat__send-button"
      data-testid="send-button"
      disabled={!hasSendableData}
      onClick={sendMessage}
      type="button"
      {...rest}
    >
      <SendIcon className="messaging-send-button__icon" fontSize="small" />
    </button>
  )
}

export default MessagingSendButton
